export default __webpack_public_path__ + "static/media/learnRegEx.73606f3a.jpg";